<template>
  <image-display :caption="'Live webcam'" :img-src="url"></image-display>
</template>

<script>
  /* TODO: Push this module into the observation panel */
  import { CameraConnection } from '../js/common';
  import ImageDisplay from './imageDisplay.vue';

  export default {
    components: {ImageDisplay},
    name: 'webcam',
    props: ['telescope'],

    data: function() {
      return {
        imageNotFound: 'loading.jpg',
        camproxyURL: 'https://rticam.lco.global',
        imageFound: '',
        isWebcamConnected: false
      };
    },
    computed: {
      url: function() {
        return (this.isWebcamConnected ? this.imageFound : this.imageNotFound);
      }
    },
    mounted: function() {
      this.imageFound = this.camproxyURL +
        '/' + this.telescope.telescope +
        '.' + this.telescope.observatory +
        '.' + this.telescope.site;

      let cameraConnection = new CameraConnection(this.imageFound);
      let that = this;
      cameraConnection.isConnected(function(result) {
        that.isWebcamConnected = result;
      });
    }
  };
</script>